<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline='true'>
          <el-form-item>
            <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="listLoading"
        ref="multipleTable"
        @current-change='currentChange'
        :highlight-current-row='true'
    >
      <el-table-column type='index' label="序号" width='80' align="center" :index='indexMethod'></el-table-column>
      <el-table-column prop="oproomExamSeatTypeName" label="考位类型" width="" align="center" ></el-table-column>
      <el-table-column prop="oproomProfessionDirName" label="职业等级方向" width="" align="center" ></el-table-column>
      <el-table-column prop="name" label="考位总时长（分钟）" width="" align="center" >
        <template #default="scope">
          {{(scope.row.extraDuration+scope.row.keySkillDuration+scope.row.noKeySkillDuration)/60}}
        </template>
      </el-table-column>
      <el-table-column prop="extraDuration" label="关键技能额外时长" width="" align="center" >
        <template #default="scope">
          {{(scope.row.extraDuration)/60}}
        </template>
      </el-table-column>
      <el-table-column prop="keySkillDuration" label="关键技能实际时长（分钟）" width="" align="center" >
        <template #default="scope">
          {{(scope.row.keySkillDuration)/60}}
        </template>
      </el-table-column>
      <el-table-column prop="noKeySkillDuration" label="非关键技能（分钟）" width="" align="center" >
        <template #default="scope">
          {{(scope.row.noKeySkillDuration)/60}}
        </template>
      </el-table-column>
      <!--      <el-table-column prop="extraDuration" label="额外时长" width="" align="center" ></el-table-column>-->
      <el-table-column prop="ddCommonStatus" label="状态" width=""  align="center" >
        <template #default='scope' >
          <el-tag v-if='scope.row.ddCommonStatus === 1' type="success">{{'启用'}}</el-tag>
          <el-tag v-if='scope.row.ddCommonStatus === 2' type='warning'>{{'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间" width="" align="center" >
        <!--        <template #default="scope">-->
        <!--          {{scope.row.createTime.split('T')[0]}}&nbsp;{{scope.row.createTime.split('T')[1].split('.')[0]}}-->
        <!--        </template>-->
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageIndex"
          :page-sizes="pages.pageArr"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.dataCount">
      </el-pagination>
    </el-col>
    <el-dialog
        :title= "editFalse?'编辑':'添加'"
        :visible.sync="dialogs.addType.dialog"
        width="40%"
        :close-on-click-modal='false'
    >
      <el-form :model="addForm"  ref="addFormRef" label-width="250px">
        <el-form-item label="考位类型：">
          <el-select v-model="addForm.oproomExamSeatTypeId" style="width: 80%"  placeholder="请选择" filterable clearable>
            <el-option
                v-for="item in selectChange"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职业等级方向：">
          <el-select v-model="addForm.oproomProfessionDirId"  style="width: 80%" placeholder="请选择" filterable clearable>
            <el-option
                v-for="item in registerType"
                :key="item.id"
                :label="item.professionDirName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考位总时长：">
          <template #default="scope">
            <el-input disabled v-model="addForm.sumSkillDuration" style="width: 80%"></el-input>
          </template>
        </el-form-item>
        <el-form-item label="关键技能鉴定点和值（分钟）：">
          <el-input disabled v-model="addForm.keySkillDuration" placeholder="关键技能鉴定点和值（分钟）" style="width: 80%;margin-bottom: 10px;"></el-input>
        </el-form-item>
	      <el-form-item label="额外时长（分钟）：">
		      <el-input v-model="addForm.extraDuration" placeholder="额外时长（分钟）" style="width: 80%;margin-bottom: 10px;"></el-input>
	      </el-form-item>
	      <el-form-item label="非关键技能鉴定点和值（分钟）：">
		      <el-input disabled v-model="addForm.noKeySkillDuration" placeholder="非关键技能鉴定点和值（分钟）" style="width: 80%;margin-bottom: 10px;"></el-input>
	      </el-form-item>
        <el-form-item label='状态：' prop='webUrl'>
          <template>
            <el-radio-group v-model="addForm.ddCommonStatus">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">禁用</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
      </el-form>
      <span v-if="!editFalse" slot="footer" class="dialog-footer">
                <el-button @click="dialogs.addType.dialog = false">取 消</el-button>
                <el-button type="primary" @click="addConfirm" :loading="loading">确认</el-button>
            </span>
      <span v-else slot="footer" class="dialog-footer">
                <el-button @click="dialogs.addType.dialog = false">取 消</el-button>
                <el-button type="primary" @click="showConfirm" :loading="loading">确认</el-button>
            </span>
    </el-dialog>
    <el-dialog
        title= "提示"
        :visible.sync="dialogs.addType.confirm"
        width="30%"
        :close-on-click-modal='false'
    >
      <el-form   ref="addFormRef" label-width="100px">
        <el-form-item label="职业功能：">
          {{'该分类下的数据将停止使用”，确定禁用吗？'}}
        </el-form-item>
      </el-form>
      <span  slot="footer" class="dialog-footer">
                <el-button @click="dialogs.addType.confirm = false">取 消</el-button>
                <el-button type="primary" @click="editConfirm" :loading="loading">确认</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
  getExamSeatExtraDurationList,
  getByNamespace,
  addExamSeatExtraDuration,
  updateExamSeatExtraDuration,
  getExtraDurationByCondition, getOproomProfessionDirList, getExamSeatTypeList,
} from '../../api/api'

export default {
  components:{Toolbar},
  data() {
    return {
      buttonList:[],
      tableData: [],
      areaArr: [],
      listLoading: false,
      //关于分页的obj
      pages: {
        pageSize: 20,//默认每页条数
        pageArr: [10, 20, 30, 40],//默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      dialogs:{
        addType:{
          dialog:false,
          confirm:false,
        },
        confirm:false,
      },
      addForm:{
        oproomProfessionDirId:undefined,
        oproomExamSeatTypeId:undefined,
        id:undefined,
        sumSkillDuration:undefined,
        keySkillDuration:undefined,
        noKeySkillDuration:undefined,
        extraDuration:undefined,
        ddCommonStatus:1,
      },
      loading:false,
      addFormRules:[],
      editFalse:false,
      pointName:[],
      grade:[],
      examPosition:[],
      skillTypes:[
        {value:1,name:'关键技能'},
        {value:2,name:'非关键技能'},
      ],
      registers:[],
      pointNums:[],
      nameSpaceTo:[],
      registerType:[],
      selectChange:[],


    }
  },
  methods: {
    //选项
    changeSelect(){
      let param = {
        pageIndex:1,
        pageSize:20,
	      ddCommonStatus:1,
      }
      getOproomProfessionDirList(param).then(res=>{
        if (res.data.success){
          this.registerType = res.data.response.data
        }
      })
      let re = {
        pageIndex:1,
        pageSize:20,
	      ddIdExamSeatStatus:1,
      }
      getExamSeatTypeList(re).then(res=>{
        if (res.data.success){
          this.selectChange = res.data.response.data
        }
      })
    },
    rowClass () {
      return 'padding:8px!important;'
    },
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    getListData(){
      this.pages = {
        pageIndex: 1,
        pageSize: 20,
      }
      this.getDataList()
    },
    // 列表查询接口
    getDataList(){
      var params = {
        pageIndex: this.pages.pageIndex,//页码
        pageSize: this.pages.pageSize,//页数
        examSeatTypeId:undefined,//
        oproomProfessionDirId:undefined,//
      }
      this.listLoading = true
      getExamSeatExtraDurationList(params).then(res => {
        var result = res.data
        if(result.success) {
          this.tableData = result.response.data
          this.pages.dataCount = result.response.dataCount
          this.getNamespace('BizService.OpRoomService.ExamSeatStatus')
        }
        this.listLoading = false
      })
    },
    changeDir(val){
      let params = {
        examSeatTypeId:this.addForm.oproomExamSeatTypeId,
        oproomProfessionDirId:val,
      }
      getExtraDurationByCondition(params).then(res=>{
        if (res){
          let response = res.data.response
	        // console.log(response,'wwweee')
          this.addForm={
            oproomProfessionDirId:val,
            oproomExamSeatTypeId:response.examSeatTypeId,
            id:this.needData?this.needData.id:undefined,
            sumSkillDuration:response.sumSkillDuration/60,
            keySkillDuration:response.keySkillDuration/60,
            noKeySkillDuration:response.noKeySkillDuration/60,
            extraDuration:this.needData?this.needData.extraDuration:undefined,
            ddCommonStatus:1,
          }
          // console.log(res,'res')
        }
      })
    },
    async handleAdd(){
      this.addForm={
        oproomProfessionDirId:undefined,
        oproomExamSeatTypeId:undefined,
        id:undefined,
        sumSkillDuration:undefined,
        keySkillDuration:undefined,
        noKeySkillDuration:undefined,
        extraDuration:undefined,
        ddCommonStatus:1,
      }
      this.changeSelect()
      this.editFalse = false ;
      this.dialogs.addType.dialog = true;
    },
    async addConfirm(){
      let params = {
        ...this.addForm,
        extraDuration:parseInt(this.addForm.extraDuration)*60,
      }
      const res = await addExamSeatExtraDuration(params)
      if (res.data.success){
        this.getListData()
        this.dialogs.addType.dialog = false ;
        this.$message({
          message:res.data.message,
          type:'success'
        })
      }else{
        this.$message({
          message:res.data.message,
          type:'warning'
        })
      }
    },
    handleEdit(){
      if (!this.needData){
        this.$message({
          message:'请选择一条数据',
          type:'warning'
        })
        return;
      }

      this.editFalse = true;
      this.addForm = {
        oproomProfessionDirId:this.needData.oproomProfessionDirId,
        oproomExamSeatTypeId:this.needData.oproomExamSeatTypeId,
        id:this.needData.id,
        sumSkillDuration:(this.needData.keySkillDuration+this.needData.noKeySkillDuration+this.needData.extraDuration)/60,
        keySkillDuration:this.needData.keySkillDuration/60,
        noKeySkillDuration:this.needData.noKeySkillDuration/60,
        extraDuration:this.needData.extraDuration/60,
        ddCommonStatus:this.needData.ddCommonStatus,
      }
      this.changeSelect()
      this.dialogs.addType.dialog = true;
    },
    showConfirm() {
      if (this.addForm.ddCommonStatus === 2){
        this.dialogs.addType.confirm = true
      }else {
        this.editConfirm()
      }
    },
    async editConfirm(){
      let params = {
        ...this.addForm,
        id:this.needData.id,
        extraDuration:parseInt(this.addForm.extraDuration)*60
      }
      const res = await updateExamSeatExtraDuration(params)
      if (res.data.success){
        this.getDataList()
        this.dialogs.addType.dialog = false ;
        this.dialogs.addType.confirm = false ;
        this.$message({
          message:res.data.message,
          type:'success'
        })
      }else{
        this.$message({
          message:res.data.message,
          type:'warning'
        })
      }
      this.editFalse = false;
    },
    //禁用
    async disable(){
      if (!this.needData){
        this.$message({
          message:'请选择一条数据',
          type:'warning'
        })
        return;
      }
      let params = {
        ...this.needData,
        ddCommonStatus:2,
        extraDuration:this.needData.extraDuration
      }
      const res = await updateExamSeatExtraDuration(params)
      if (res.data.success){
        this.getDataList()
        this.dialogs.addType.dialog = false ;
        this.dialogs.addType.confirm = false ;
        this.$message({
          message:res.data.message,
          type:'success'
        })
      }else{
        this.$message({
          message:res.data.message,
          type:'warning'
        })
      }
    },




    //获取字符空间
    async getNamespace(name){
      let params = {
        namespace:name,
      }
      const res = await  getByNamespace(params)
      // console.log(res,'res')
      if (res.data.success){
        this.nameSpaceTo = res.data.response
      }
    },


    // 点击table某一行
    currentChange(val) {
      this.needData = val
      console.log(val,'val')
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getDataList();
    },
    handleSizeChange(val){
      this.pages.pageSize = val;
      this.getDataList();
    },
    // 时间格式化
    formatCreateTime: function(row, column) {
      return !row || row == ""
          ? ""
          : util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm");
    },
    // 表格数据分页条数累计
    indexMethod(index) {
      var currentPage = this.pages.pageIndex
      var pageSize = this.pages.pageSize
      return (index + 1) + (currentPage - 1) * pageSize
    },
  },
  watch: {
	  'addForm.oproomProfessionDirId': {
		  handler(newQuestionCode, oldQuestionCode) {
			  // 调用 splitQuestionId 方法并更新 addForm.questionTypeCode
			  this.changeDir(this.addForm.oproomProfessionDirId);
		  },
		  immediate: true, // 立即执行一次以确保初始值也被处理
	  },
  },
  created(){
    this.utils = util
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getListData();
  },
}
</script>

<style lang="stylus" scoped>
.projectName {
  text-align: center;
}
.projectSelect {
  margin-bottom: 15px;
}
.projectTitle {
  margin-bottom: 15px
}
.replyBtn {
  margin: 10px 0;
  color: #409eff;
  cursor: pointer;
  width: 30px;
}
.replyMessage {
  background: #eee;
  line-height: 30px;
  padding: 5px;
  border-radius: 2px;
  margin: 5px 15px;
}
.titleTimer {
  margin-left: 10px;
}
.green_t {
  color: green;
}
.red_t {
  color: red;
}
</style>
